import type React from 'react';

import type { IconType } from '@zillow/constellation';
import { Box, Text } from '@zillow/constellation-10';
import { StyledLink } from './styles';

type Props = {
  ActiveIcon?: React.ComponentType<React.PropsWithChildren<React.PropsWithChildren<typeof IconType>>> | null;
  InactiveIcon?: React.ComponentType<React.PropsWithChildren<React.PropsWithChildren<typeof IconType>>> | null;
  isActive?: boolean;
  title: string;
  toPath?: string;
  isInMenuPopper?: boolean;
};

const NavItem = ({
  title,
  isActive = false,
  toPath = '',
  ActiveIcon = null,
  InactiveIcon = null,
  isInMenuPopper,
}: Props) => {
  return (
    <Box
      data-testid="NavItem"
      css={{ md: { width: '131px' }, ...(isInMenuPopper && { width: '100%', display: 'flex' }) }}
    >
      <StyledLink
        isActive={isActive}
        to={{
          pathname: toPath,
        }}
      >
        <Box
          css={{
            display: 'flex',
            flexDirection: isInMenuPopper ? 'row' : 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          data-testid="NavItem-ContentContainer"
        >
          <Box
            css={{
              display: 'flex',
              alignItems: 'center',
              marginRight: { base: '200', md: 0 },
              marginBottom: { base: 0, md: '200' },
            }}
          >
            {isActive ? ActiveIcon && <ActiveIcon size="sm" /> : InactiveIcon && <InactiveIcon size="sm" />}
          </Box>
          <Box css={{ marginBottom: 0 }}>
            <Text
              textStyle={isActive ? 'body-xs-bold' : 'body-xs'}
              css={{
                color: 'inherit',
                '@media (min-width: 390px) and (max-width: 480px)': {
                  fontSize: isActive ? 'body-sm' : 'body-xs',
                },
                md: {
                  textStyle: isActive ? 'body-bold' : 'body',
                },
              }}
            >
              {title}
            </Text>
          </Box>
        </Box>
      </StyledLink>
    </Box>
  );
};

export default NavItem;
